import React from "react";

function PolicyViewer({ policy }) {
  // Determine which URL to display based on status
  const pdfUrl = policy.status === "final" || policy.status === "approved" 
    ? policy.final_url 
    : policy.draft_url;

  return (
    <div
      style={{
        padding: "20px",
        background: "#f9f9f9",
        border: "1px solid #ccc",
        borderRadius: "8px",
      }}
    >
      <h4 style={{ color: "#0d47a1", marginBottom: "15px" }}>
        {policy.name} ({policy.status})
      </h4>

      {/* Show approval/rejection remarks if available */}
      {policy.approval_remarks && (
        <div style={{ 
          backgroundColor: "#e8f5e9", 
          padding: "10px", 
          borderRadius: "5px",
          marginBottom: "15px",
          border: "1px solid #4caf50"
        }}>
          <strong style={{ color: "#2e7d32" }}>Approval Remarks:</strong>
          <p style={{ margin: "5px 0 0 0", color: "#333" }}>{policy.approval_remarks}</p>
          <small style={{ color: "#666" }}>
            Approved by: {policy.approved_by_name} ({policy.approved_by_designation})
          </small>
        </div>
      )}

      {policy.rejection_remarks && (
        <div style={{ 
          backgroundColor: "#ffebee", 
          padding: "10px", 
          borderRadius: "5px",
          marginBottom: "15px",
          border: "1px solid #f44336"
        }}>
          <strong style={{ color: "#c62828" }}>Rejection Remarks:</strong>
          <p style={{ margin: "5px 0 0 0", color: "#333" }}>{policy.rejection_remarks}</p>
          <small style={{ color: "#666" }}>
            Rejected by: {policy.rejected_by_name} ({policy.rejected_by_designation})
          </small>
        </div>
      )}

      {/* PDF Display */}
      {pdfUrl ? (
        <div style={{ marginTop: "20px" }}>
          <iframe
            src={pdfUrl}
            width="100%"
            height="600px"
            style={{ border: "1px solid #ccc", borderRadius: "5px" }}
            title="Policy PDF Viewer"
          />
          <div style={{ marginTop: "10px", textAlign: "center" }}>
            <a 
              href={pdfUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                color: "#1976d2",
                textDecoration: "none",
                fontWeight: "bold"
              }}
            >
              Open PDF in New Tab
            </a>
          </div>
        </div>
      ) : (
        <p style={{ color: "#999", fontStyle: "italic" }}>No PDF generated yet.</p>
      )}
    </div>
  );
}

export default PolicyViewer;